import React, { useState } from 'react';
import { Select, Space } from 'antd';
import Styles from './styles.module.css'
// The fixed status options (derived from your column filters)


const EditableStatusCell = ({ value, record, dataIndex, onStatusChange=null }) => {
  const [editing, setEditing] = useState(false);

  const STATUS_OPTIONS = (value !== "In Progress" && value !== "Live" && value !== "Pre Live")  ? [
  { label: "Not started", value: "Not started" },
  { label: "In Progress", value: "In Progress" },
//   { label: "Pre Live", value: "Pre Live" },
//   { label: "Live", value: "Live" },
]:[
  // { label: "Not started", value: "Not started" },
  { label: "In Progress", value: "In Progress" },
//   { label: "Pre Live", value: "Pre Live" },
//   { label: "Live", value: "Live" },
] ;

  const handleStatusChange = (newValue) => {
    // console.log("Status changed to:", newValue);
    // console.log("Record:", record);
    // console.log("DataIndex:", dataIndex);
    onStatusChange(record._id, dataIndex, newValue);
    setEditing(false);
  };

  const renderDisplay = () => (
    <div
      onClick={() => setEditing(true)}
      className={Styles['selection-div']}
    >
      {value || "N/A"}
    </div>
  );

  const renderEditor = () => (
    <Select
    disabled={value === "Live" || value === "Pre Live"}
      value={value}
      options={STATUS_OPTIONS}
      onChange={handleStatusChange}
      onBlur={() => setEditing(false)} // Exit edit mode if user clicks away
      autoFocus // Focus the select box when it appears
      style={{ width: '100%' }}
    />
  );

  return editing ? renderEditor() : renderDisplay();
};

export default EditableStatusCell;